require('./insuranceRequestProductDetail.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { getLastPayment } = require('../../insuranceUtilities/payments')
const { getFormattedString } = require('utilities/currencyHelper');
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { InsuranceRequestProductHomeDetail } = require('./insuranceRequestProductHomeDetail/insuranceRequestProductHomeDetail');
const InsuranceRequestProductMobileDetail = require('./insuranceRequestProductMobileDetail/insuranceRequestProductMobileDetail');
const InsuranceMortgageDetail = require('./insuranceMortgageDetail/insuranceMortgageDetail');

//@constants
const { EURO_TEXT } = require('constants/index');
const { POLICY_STATUS, PRODUCT_TYPE } = require('../../insuranceConstants/insuranceRequestTypes');
const FOUR_LAST_CHARACTERS = 4;

// @ actions
const insuranceRequestProductDetailActions = require('../../actions/insuranceRequest/insuranceRequestProductDetail');

class InsuranceRequestProductDetail extends React.Component {

    constructor(props) {
        super(props);

        this.buildItems = this.buildItems.bind(this);
        this.buildDescriptionTopBox = this.buildDescriptionTopBox.bind(this);
        this.handleOpenPdfDocument = this.handleOpenPdfDocument.bind(this);
    }

    componentWillMount() {
        const {
            immPolicy,
            getProductDetail,
        } = this.props;

        getProductDetail(immPolicy.get('policyNumber'));
    }

    getImmPolicy(policyNumber) {
        const { immInsurances } = this.props;

        const insurances = immInsurances.get('insurances');
        const immPolicy = insurances.filter((insurance) => insurance.get('policyNumber') === policyNumber);

        return immPolicy.first();

    }

    getLastAmmountReceived() {
        const { immPolicy } = this.props

        return getLastPayment(immPolicy);
    }

    buildItems(label, number) {
        return (
            <li className="insurance-request-product-detail-description-ok-section-top__list">
                {label}
                <span
                    className="insurance-request-product-detail-description-ok-section-top__list-item"
                >
                    {number}
                </span>
            </li>
        )
    }

    handleOpenPdfDocument() {
        const { getPolicyDocument, immPolicy } = this.props;

        const policyNumber = immPolicy.get('policyNumber')
        const policyVersion = immPolicy.get('policyVersion');
        getPolicyDocument(policyNumber, policyVersion);
    }

    buildDescriptionTopBox() {
        const {
            immInsuranceRequestProductDetailDescription,
            immPolicy
        } = this.props;

        const immProductDetailData = immInsuranceRequestProductDetailDescription.get('response');
        const detailCompanyInfo = immProductDetailData.getIn(['insuranceCompanyDto', 'companyGroup']) || '';
        const immPolicyDetails = immProductDetailData.get('policyBasicInformationDto');

        const insuranceTitle = immPolicyDetails.get('productName') === PRODUCT_TYPE.MOBILE_INSURANCE ?
            formatText('insuranceConsultiveProductDetails-titleMobile') :
            formatText('insuranceConsultiveProductDetails-title');
        const insuranceSubtitle = formatText('insuranceConsultiveProductDetails-subtitle');
        const lastReceipt = formatText('insuranceConsultiveProductDetails-importLastBill');
        const lastReceiptInfo = this.getLastAmmountReceived();
        const formatedLastReceiptInfo = lastReceiptInfo > 0 ? getFormattedString({
            amount: lastReceiptInfo,
            currency: EURO_TEXT,
            decimalsLength: 2
        }): '-';
        const associatedAccount = formatText('insuranceConsultiveProductDetails-associatedAccount');
        const associatedAccountInfo = immPolicyDetails.get('account') || '';
        const formattedAssociatedAccounInfo = `****${associatedAccountInfo.substring(associatedAccountInfo.length - FOUR_LAST_CHARACTERS)}`;
        const wayToPay = formatText('insuranceConsultiveProductDetails-paymentForm');
        const wayToPayInfo = immPolicyDetails.get('paymentType') || '';
        const wayToPayInfoLowerCase = wayToPayInfo.toLowerCase();
        const wayToPayCopy = formatText(`insuranceConsultiveProductDetails-${wayToPayInfoLowerCase}`);
        const policyNumberTitle = formatText('insuranceConsultiveProductDetails-policyNumber');
        const policyNumberInfo = immPolicyDetails.get('policyNumber') || '';
        const policyTerms = formatText('insuranceConsultiveProductDetails-policyValidity');
        const effectiveDate = immPolicyDetails.get('startDate');
        const effectiveEndDate = immPolicyDetails.get('effectiveEndDate');
        const policyTermsInfo = `${effectiveDate} - ${effectiveEndDate}`;
        const effectiveDateNoDash = effectiveDate.split('-').join("");
        const currentDate = DateHelper.formatDate(new Date(), 'YYYYMMDD');
        const company = formatText('insuranceConsultiveProductDetails-company');
        const companyInfoLowerCase = detailCompanyInfo.toLowerCase();
        const companyInfoCopy = formatText(`insuranceConsultiveProductDetails-${companyInfoLowerCase}`);
        const canWeHelp = formatText('insuranceConsultiveProductDetails-canWeHelp');
        const sinisterAssistance = formatText('insuranceConsultiveProductDetails-sinisterAssistance');
        const sinisterAssistancePhone = formatText('insuranceConsultiveProductDetails-sinisterAssistancePhone');
        const insuranceInformation = formatText('insuranceConsultiveProductDetails-insuranceInformation');
        const buttonLabel = formatText('insuranceConsultiveProductDetails-viewPolicy');
        const insuranceInformationPhone = formatText('insuranceConsultiveProductDetails-insuranceInformationPhone');
        const policyStatus = immPolicy.get('policyStatus');
        const showInsuranceSubtitle = policyStatus === POLICY_STATUS.VIGOR && (currentDate >= effectiveDateNoDash) ? (
            <div className="insurance-request-product-detail-description-ok-section-top__ok-box-title">
                {insuranceSubtitle}
            </div>
        ) : null

        return (
            <article>
                <OKBoxTitle
                    value={insuranceTitle}
                    inline={true}
                >
                    {showInsuranceSubtitle}
                </OKBoxTitle>
                <span className="insurance-request-product-detail-description-ok-section-top__button">
                    <OKButton
                        modifier="ghost"
                        onClick={this.handleOpenPdfDocument}
                    >
                        {buttonLabel}
                    </OKButton>
                </span>
                <section className="insurance-request-product-detail-description-ok-section-top__body">
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title={lastReceipt}
                            bodyText={formatedLastReceiptInfo}
                        >
                        </OKInformativeListItem>
                        <OKInformativeListItem
                            title={associatedAccount}
                            bodyText={formattedAssociatedAccounInfo}
                        />
                        <OKInformativeListItem
                            title={wayToPay}
                            bodyText={wayToPayCopy}
                        />
                        <OKInformativeListItem
                            title={policyNumberTitle}
                            bodyText={policyNumberInfo}
                        />
                        <OKInformativeListItem
                            title={policyTerms}
                            bodyText={policyTermsInfo}
                        />
                        <OKInformativeListItem
                            title={company}
                            bodyText={companyInfoCopy}
                        />
                    </OKInformativeList>
                </section>
                <section className="insurance-request-product-detail-description-ok-section-top__information">
                    <span className="insurance-request-product-detail-description-ok-section-top__phone-number">
                        <label>{canWeHelp}</label>
                    </span>
                    <ul className="insurance-request-product-detail-description-ok-section-top__list-group">
                        {this.buildItems(sinisterAssistance, sinisterAssistancePhone)}
                        {this.buildItems(insuranceInformation, insuranceInformationPhone)}
                    </ul>
                </section>
            </article>
        );
    }

    getMortgageInsurance(contractNumber) {
        const { immLoans } = this.props;
        const mortgageList = immLoans.get('byId');

        const currentMortgage = mortgageList.find(mortgage => mortgage.get('newContractNumber') === contractNumber)

        return currentMortgage ? {
            link: '/myprofile/loans-mortgages/loans/' + currentMortgage.get('loanId'),
            title: currentMortgage.get('alias'),
        } : null;
    }

    getContractNumber(immPolicyDetails) {
        const { immInsurances } = this.props;

        const policyNumber = immPolicyDetails ? immPolicyDetails.get('policyNumber') : null;
        const insuranceList = immInsurances.get('insurances');
        const currentInsurance = insuranceList.find(insurance => insurance.get('policyNumber') === policyNumber);

        return currentInsurance ?
            currentInsurance.getIn(['complementaryInformation', 'mortgage', 'contractNumber']) : null;
    }

    render() {
        const { immInsuranceRequestProductDetailDescription, isDisclaimerMobileEnabled } = this.props;

        const immProductDetailData = immInsuranceRequestProductDetailDescription.get('response');
        const isFetching = immInsuranceRequestProductDetailDescription.get('isFetching');
        const immPolicyComplementaryInformation = immProductDetailData.get('policyComplementaryInformation');
        const immPolicyDetails = immProductDetailData.get('policyBasicInformationDto');
        const contractNumber = this.getContractNumber(immPolicyDetails);
        const mortgage = contractNumber ? this.getMortgageInsurance(contractNumber) : null ;

        if ((!immPolicyComplementaryInformation && !immPolicyDetails) || isFetching) {
            return <LoadingSection />
        }

        let insuranceDetail, mortgageDetail;
        if (immPolicyDetails.get('productName') === PRODUCT_TYPE.HOME) {
            insuranceDetail = (
                <InsuranceRequestProductHomeDetail
                    immPolicyComplementaryInformation={immPolicyComplementaryInformation}
                    immPolicyDetails={immPolicyDetails}
                />
            );
        } else if (immPolicyDetails.get('productName') === PRODUCT_TYPE.MOBILE_INSURANCE) {
            insuranceDetail = (
                <InsuranceRequestProductMobileDetail
                    immPolicyComplementaryInformation={immPolicyComplementaryInformation}
                    immPolicyDetails={immPolicyDetails}
                    isDisclaimerMobileEnabled={isDisclaimerMobileEnabled}
                />
            );
        }

        if (mortgage) {
            mortgageDetail = (
                <InsuranceMortgageDetail
                    mortgage={mortgage}
                />
            );
        }

        return (
            <React.Fragment>
                <OKSectionBox className="insurance-request-product-detail-description-ok-section-top">
                    {this.buildDescriptionTopBox()}
                </OKSectionBox>
                {insuranceDetail}
                {mortgageDetail}
            </React.Fragment>
        );
    }
}

InsuranceRequestProductDetail.propTypes = {
    immInsuranceRequestProductDetailDescription: PropTypes.object.isRequired,
    immInsurances: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    immPolicy: PropTypes.object.isRequired,
    isDisclaimerMobileEnabled:PropTypes.bool.isRequired,
    getProductDetail: PropTypes.func.isRequired,
    getPolicyDocument: PropTypes.func.isRequired,
};

module.exports.constructor = InsuranceRequestProductDetail;

module.exports.InsuranceRequestProductDetail = connect(
    state => ({
        immInsuranceRequestProductDetailDescription: state.insuranceRequestProductDetailDescription,
        immInsurances: state.insuranceRequestLanding,
        immLoans: state.loans
    }),
    {
        getProductDetail: insuranceRequestProductDetailActions.getProductDetail,
        getPolicyDocument: insuranceRequestProductDetailActions.getPolicyDocument
    }
)(InsuranceRequestProductDetail);
